import { HiOutlineExclamationCircle, HiOutlineTrash } from "react-icons/hi";
import { PiClockCounterClockwise } from "react-icons/pi";
import toast from "react-hot-toast";

const AdmissionCodeContextMenu = ({
  admission,
  contextMenu,
  selectedCodes,
  setSelectedCodes,
  setContextMenu,
  onAdmissionChange,
  onRenewalMarked,
}) => {
  if (contextMenu.visible !== true) return null;

  return (
    <div
      className="fixed z-50 min-w-[180px] overflow-hidden rounded-md border border-gray-200 bg-white py-1 shadow-lg"
      style={{ top: contextMenu.y, left: contextMenu.x }}
      data-context-menu="true"
    >
      <button
        className="flex w-full items-center gap-2 px-3 py-1.5 text-left text-xs text-gray-700 transition-colors hover:bg-gray-50"
        onMouseDown={(event) => {
          event.stopPropagation();
          onAdmissionChange([
            {
              field: "prescriptions",
              value: admission.prescriptions.map((prescription) => ({
                ...prescription,
                acts: prescription.acts.map((act) => {
                  const nextCodes = act.codes.filter((code) => !selectedCodes.includes(`${prescription._id}:${code}`));
                  return { ...act, codes: nextCodes, isDeleted: nextCodes.length === 0 ? true : act.isDeleted };
                }),
              })),
            },
          ]);
          setSelectedCodes([]);
          setContextMenu((prev) => ({ ...prev, visible: false, x: 0, y: 0 }));
          toast.success("Code(s) supprimé(s)");
        }}
      >
        <HiOutlineTrash className="h-3.5 w-3.5 text-gray-400" />
        Supprimer
      </button>

      <button
        className="flex w-full items-center gap-2 px-3 py-1.5 text-left text-xs text-gray-700 transition-colors hover:bg-gray-50"
        onMouseDown={(event) => {
          event.stopPropagation();
          const nextAldStatus = !contextMenu.allSelectedAreALD;
          onAdmissionChange([
            {
              field: "prescriptions",
              value: admission.prescriptions.map((prescription) => ({
                ...prescription,
                acts: prescription.acts.map((act) => {
                  const prescriptionPrefix = `${prescription._id}:`;
                  if (act.codes.some((code) => selectedCodes.includes(prescriptionPrefix + code))) return { ...act, ALD: nextAldStatus };
                  return act;
                }),
              })),
            },
          ]);
          setSelectedCodes([]);
          setContextMenu((prev) => ({ ...prev, visible: false, x: 0, y: 0 }));
          toast.success(nextAldStatus ? "Code(s) marqué(s) comme ALD" : "ALD retirée des code(s)");
        }}
      >
        <HiOutlineExclamationCircle className="h-3.5 w-3.5 text-gray-400" />
        {contextMenu.allSelectedAreALD ? "Enlever l'ALD" : "Marquer comme ALD"}
      </button>

      <button
        className="flex w-full items-center gap-2 px-3 py-1.5 text-left text-xs text-gray-700 transition-colors hover:bg-gray-50"
        onMouseDown={(event) => {
          event.stopPropagation();
          const nextRenewalStatus = !contextMenu.allSelectedAreRenewal;
          const newlyRenewableCodes = selectedCodes.filter((selectedCode) => {
            const [prescriptionId, code] = selectedCode.split(":");
            const act = admission.prescriptions.find((prescription) => prescription._id === prescriptionId).acts.find((item) => item.codes.includes(code));
            return !act.renewal?.enabled;
          });
          onAdmissionChange([
            {
              field: "prescriptions",
              value: admission.prescriptions.map((prescription) => ({
                ...prescription,
                acts: prescription.acts.map((act) => {
                  const prescriptionPrefix = `${prescription._id}:`;
                  if (!act.codes.some((code) => selectedCodes.includes(prescriptionPrefix + code))) return act;
                  if (nextRenewalStatus && act.renewal?.enabled) return act;
                  return { ...act, renewal: { enabled: nextRenewalStatus } };
                }),
              })),
            },
          ]);
          setSelectedCodes([]);
          setContextMenu((prev) => ({ ...prev, visible: false, x: 0, y: 0 }));
          if (!nextRenewalStatus) return toast.success("Renouvellement retiré des code(s)");
          const [prescriptionId, code] = newlyRenewableCodes[0].split(":");
          onRenewalMarked(prescriptionId, code);
        }}
      >
        <PiClockCounterClockwise className="h-3.5 w-3.5 text-gray-400" />
        {contextMenu.allSelectedAreRenewal ? "Retirer le renouvellement" : "Marquer comme renouvelable"}
      </button>
    </div>
  );
};

export default AdmissionCodeContextMenu;
